import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "Tap to work on your own wedding", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Tap to start planning your own wedding", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_m_input = _resolveComponent("m-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/tabs/home/settings" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Planning Partners')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list_header, { color: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.showForm ? _ctx.$t("Invite Planning Partner") : _ctx.$t("Planning Partners")), 1)
                ]),
                _: 1
              }),
              _withDirectives(_createVNode("div", null, [
                (_ctx.store.state.weddingPartners.planners.length > 0 && !_ctx.showForm)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.store.state.weddingPartners.planners, (planner) => {
                      return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                        key: planner.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.chevronBack
                              }, null, 8, ["icon"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createVNode("h3", null, _toDisplayString(planner.name), 1),
                                  _createVNode("p", null, _toDisplayString(planner.email), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item_options, { side: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item_option, {
                                color: "primary-contrast",
                                onClick: ($event: any) => (_ctx.deletePlanner(planner.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.closeCircleOutline,
                                    color: "danger",
                                    style: {"font-size":"30px"}
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", null, [
                  _createVNode(_component_m_input, {
                    label: _ctx.$t('Name'),
                    name: "name"
                  }, null, 8, ["label"]),
                  _createVNode(_component_m_input, {
                    type: "email",
                    label: _ctx.$t('Email'),
                    name: "email"
                  }, null, 8, ["label"]),
                  _createVNode(_component_m_input, {
                    type: "email",
                    label: _ctx.$t('Confirm Email'),
                    name: "emailConfirmation"
                  }, null, 8, ["label"]),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        color: "dark",
                        slot: "start",
                        onClick: _ctx.onSubmitForm
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.personAdd
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Save')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        color: "danger",
                        slot: "end",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showForm = false; _ctx.resetForm()})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.closeCircle
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Cancel')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _ctx.showForm]
                ]),
                _withDirectives(_createVNode(_component_ion_item, {
                  button: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showForm = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: _ctx.personAdd,
                      color: "primary"
                    }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Add a Planning Partner')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.showForm]
                ])
              ], 512), [
                [_vShow, _ctx.myWeddingIsSelected]
              ]),
              _withDirectives(_createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createVNode("p", null, _toDisplayString(_ctx.$t("You can only add planning partners to your own wedding.  Select it below to add someone.")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.myWeddingIsSelected]
              ]),
              _createVNode(_component_ion_list_header, { color: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Weddings')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                button: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectWedding(0)))
              }, {
                default: _withCtx(() => [
                  (_ctx.myWeddingIsSelected)
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        slot: "end",
                        icon: _ctx.checkmarkCircle,
                        color: "primary"
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        slot: "end",
                        icon: _ctx.checkmarkCircleOutline,
                        color: "light"
                      }, null, 8, ["icon"])),
                  (_ctx.store.state.userData.my_wedding)
                    ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode("h3", null, _toDisplayString(_ctx.$t('My Wedding')), 1),
                          _hoisted_1
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode("h3", null, _toDisplayString(_ctx.$t('Create My Wedding')), 1),
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.store.state.weddingPartners.weddings, (wedding) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  key: wedding.id,
                  button: "",
                  onClick: ($event: any) => (_ctx.selectWedding(wedding.id))
                }, {
                  default: _withCtx(() => [
                    (_ctx.store.state.userData.wedding && wedding.id == _ctx.store.state.userData.wedding.id)
                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 0,
                          slot: "end",
                          icon: _ctx.checkmarkCircle,
                          color: "primary"
                        }, null, 8, ["icon"]))
                      : (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 1,
                          slot: "end",
                          icon: _ctx.checkmarkCircleOutline,
                          color: "light"
                        }, null, 8, ["icon"])),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createVNode("h3", null, _toDisplayString(wedding.bride_firstname + _ctx.$t(" and ") + wedding.groom_firstname), 1),
                        _createVNode("p", null, _toDisplayString(wedding.owner.name) + " " + _toDisplayString(wedding.owner.email), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}